/* eslint-disable */
// JS Routes - bundled with webpack instead of separate HTTP request
import * as Routes from 'hb-routes';

import { preventBouncingViewportIssueOniOS } from 'helpers/preventBouncingViewportIssueOniOS';
import requireAll from 'helpers/requireAll';

window.Routes = Routes;

// CSS entry point
require('legacy/stylesheets/homepage_network.scss');

// Libraries
require('jquery');
require('jquery-ujs');
require('corejs-typeahead');

// Gems
require('@nathanvda/cocoon');

require('select2');
require('responsive-slides/responsiveslides');
require('libs/bootstrap/js/tooltip');
require('libs/bootstrap/js/dropdown');

require('libs/retina');

// jQuery Plugins
require('legacy/javascripts/plugins/beautifull_cover_size');
require('jquery-serializejson');
require('libs/jquery.fancybox');
require('legacy/javascripts/plugins/kit_fancybox_global');
require('libs/foundation-sites/js/foundation/foundation');
require('libs/foundation-sites/js/foundation/foundation.reveal');

// Components
require('react');
require('react-dom');
require('homepage_network_components');

// Self exposing on AlumniConnect object
window.AlumniConnect = {
  Helpers: {},
};

// exposing on Hivebrite object
const { Hivebrite } = require('hb-react/shared/utils/hivebrite');

window.Hivebrite = {
  ...(window.Hivebrite || {}),
  ...Hivebrite,
  // eslint-disable-next-line global-require
  sessionStorage: require('hb-react/shared/utils/sessionStorage'),
  sdk: require('hb-react/shared/frontendSdk').sdk,
};

// sessionStorage keys
window.Hivebrite.sessionStorage.PO_LOGIN_SOURCE = 'PO_LOGIN_SOURCE';

// exposing on HivebriteMobileApp
window.HivebriteMobileApp =
  require('hb-react/shared/utils/hivebrite').HivebriteMobileApp;

// Helpers
requireAll(require.context('helpers', false));
require('helpers/global');

// Objects
require('legacy/javascripts/objects/experiences');
require('legacy/javascripts/objects/educations');

// Initializers
require('initializers/hammerhistory');
require('initializers/pickplace');
require('initializers/react');
require('initializers/dayjs');
import('initializers/hammerjs');

window.Loader = require('legacy/javascripts/objects/loader').default;

$(() => {
  // Sticky side container
  if (!AlumniConnect.Helpers.JS.isMobile.any()) {
    let sideContainer = document.querySelector('.js-content-side-container');

    if (sideContainer) {
      sideContainer.style.position = 'fixed';
      sideContainer.style.top = '120px';
    }
  }

  // Footer display
  $('.js-network__footer').show();

  // Preventing iOS Textbox Auto Zooming and ViewPort Sizing
  preventBouncingViewportIssueOniOS();

  // Helper: Batch process images to avoid blocking main thread
  function processImagesInBatches($images, fn, batchSize = 5) {
    let i = 0;
    function nextBatch() {
      for (let j = 0; j < batchSize && i < $images.length; j++, i++) {
        fn($images[i]);
      }
      if (i < $images.length) requestAnimationFrame(nextBatch);
    }
    nextBatch();
  }

  // Defer non-critical plugin initializations
  const deferNonCritical = () => {
    // Init plugins
    $('body').tooltip({
      selector: '[data-behavior=tooltip],[data-toggle=tooltip]',
    });
    $('[data-behavior=close-parent]').click(function () {
      $(this).parent().hide();
    });
    setTimeout(() => {
      $('[data-behavior=close-parent]').trigger('click');
    }, 15000);

    // Batch process beautifullCoverSize
    if ($.fn.beautifullCoverSize) {
      const images = $('.cover-bloc-item__image').toArray();
      processImagesInBatches(images, (el) => $(el).beautifullCoverSize());
    }
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(deferNonCritical);
  } else {
    setTimeout(deferNonCritical, 0);
  }
});
